<template>
    <div class="mx-auto inline-block w-full">
        <CallToAction :href="redirectUrl"
                      variant="SecondaryButton"
                      :class="giftCardCtaClass">
            {{ $translate("GiftCard.GoToPdpButtonText") }}
        </CallToAction>
    </div>
</template>

<script lang="ts" setup>
import { CatalogProductTileViewObject } from '@/api/content/models/catalog-product-tile-view-object';
import CallToAction from '@/project/navigation/call-to-action/CallToAction.vue';
import { productService } from './product.service';

type Props = {
    product: CatalogProductTileViewObject;
    index: number;
    contentBlockIndex: number;
}

const props = defineProps<Props>();

const redirectUrl = productService.getProductRedirectUrlByProduct(props.product);

const giftCardCtaClass = 'mx-auto h-auto min-h-44 -py-10 text-16 md:px-20 md:text-18';




</script>
